var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LeftNavBar',{staticClass:"f1",attrs:{"items":_vm.$route.meta.leftNav ? _vm.navItems : [],"title":_vm.selectedAppInitial,"selectedValue":_vm.$store.state.appData.filter.value},on:{"opened":_vm.navOpened}})
}
var staticRenderFns = []

export { render, staticRenderFns }